import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Receipt } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { z } from "zod";
import { BranchDunningUserSelect } from "./branch-dunning-user-select";

export const branchDunningFormSchemaShape = {
  dunningUser: z.string().optional(),
  dunningRepresentative: z.string().optional(),
  accountingDunningClerkId: z.string().max(2, "masterdata:BranchAccountingDunningClerkIdMaxLength").optional(),
};

interface BranchFormWithDunning {
  dunningUser?: string;
  dunningRepresentative?: string;
  accountingDunningClerkId?: string;
}

export function BranchDunningFormCard() {
  const { t } = useTranslation(["masterdata", "common"]);
  const { control } = useFormContext<BranchFormWithDunning>();

  return (
    <Card className="shadow-none">
      <CardHeader className="pb-4">
        <CardTitle className="flex items-center gap-2">
          <Receipt className="h-4 w-4" />
          {t("masterdata:BranchDunning")}
        </CardTitle>
        <CardDescription>{t("masterdata:BranchDunningDescription")}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          <FormField
            control={control}
            name="dunningUser"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t("masterdata:BranchDunningUser")}</FormLabel>
                <FormControl>
                  <BranchDunningUserSelect value={field.value} onChange={field.onChange} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={control}
            name="dunningRepresentative"
            render={({ field }) => (
              <FormItem>
                <FormLabel>{t("masterdata:BranchDunningRepresentative")}</FormLabel>
                <FormControl>
                  <BranchDunningUserSelect value={field.value} onChange={field.onChange} />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        </div>

        <FormField
          control={control}
          name="accountingDunningClerkId"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("masterdata:BranchAccountingDunningClerkId")}</FormLabel>
              <FormControl>
                <Input
                  placeholder={t("masterdata:BranchAccountingDunningClerkIdExample")}
                  maxLength={2}
                  {...field}
                  value={field.value ?? ""}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
}
